let createPostRecoverPassword = ({
  fetch,
  environment,
  errorUnlessOk
}) => data => {
  let request = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  };

  return fetch(
    `${environment.authUrl}/controldeusuarios/password/confirmacion`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
};

let createSessionLogin = ({
  fetch,
  environment,
  errorUnlessOk
}) => credentials => {
  credentials.UseTokenCookie = true;

  let request = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    //credentials: 'include',
    body: JSON.stringify(credentials)
  };

  return fetch(`${environment.authUrl}/auth/login`, request)
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
};

let createSessionSendRecoveryPasswordEmail = ({
  fetch,
  environment,
  errorUnlessOk
}) => email => {
  let request = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ UserEmail: email })
  };

  return fetch(`${environment.authUrl}/controldeusuarios/password`, request)
    .then(errorUnlessOk)
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
};

let createPostVincularOperaciones = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk
}) => () => {
  let request = buildRequestWithAuth("POST");

  return fetch(
    `${environment.catalogosUrl}/apiclientes/creditos/vinculacion`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
};

export {
  createPostRecoverPassword,
  createSessionLogin,
  createSessionSendRecoveryPasswordEmail,
  createPostVincularOperaciones
};
